module.exports = __webpack_public_path__ + "img/same_index.19e5915e.png";